module.exports = __webpack_public_path__ + "assets/img/index-project2-5.bd9a455b.jpg";